import React from 'react';
import cn from 'classnames';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import Button from '@creditflowresearch/uilib/Button';
import IconArrowLeft from '@creditflowresearch/uilib/Icon/IconArrowLeft';
import { useStepFormContext } from '@/creditflowresearch/application/PortfolioMonitor/StepFormContext';

import cardStyles from '@creditflowresearch/uilib/styles/card.module.scss';
import styles from './styles.module.scss';

interface IProps {
  isLoading?: boolean,
  isSubmitDisabled: boolean,
  caption?: string,
  onCancelClick: () => void,
  submitButtonTitle?: string,
}

const FormBottomNavigation = ({ isLoading, isSubmitDisabled, caption, onCancelClick, submitButtonTitle = 'Continue' }: IProps) => {
  const { goPrev } = useStepFormContext();

  return (
    <div className={ cn(styles.formFooter, cardStyles.cardInnerHorizontal) }>
      <Button
        variant="text"
        color="primary"
        dataTest="portfolioMonitorBackButton"
        onClick={ goPrev }
        icon={ <IconArrowLeft /> }
      >
        Back
      </Button>
      { caption && (
        <div className={ styles.caption }>
          { caption }
        </div>
      ) }
      <div>
        <Button
          variant="text"
          color="primary"
          dataTest="portfolioMonitorCancelButtonButton"
          onClick={ onCancelClick }
          className={ styles.cancelButton }
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          color="primary"
          dataTest="portfolioMonitorContinueButtonButton"
          type="submit"
          disabled={ isSubmitDisabled }
        >
          { isLoading ? <Spinner size="S" color="on-color" /> : submitButtonTitle }
        </Button>
      </div>
    </div>
  );
};

export default FormBottomNavigation;
